import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export interface UserState {
    name: string,
    email: string,
    id:string
  }
  
  const initialState: UserState = {
      name: "",
      email: "",
      id: ""
  }
  
  export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
      updateUser: (state, action) => {
         state = action.payload
      }
      
    },
  })
  
  // Action creators are generated for each case reducer function
  export const { updateUser } = userSlice.actions
  
  export default userSlice.reducer